import { Component, ElementRef, QueryList, ViewChildren, inject } from '@angular/core';

import { LoginComponent } from '../../login.component';

@Component({
  selector: 'app-login-mobile-mfa-step',
  templateUrl: './login-mobile-mfa-step.component.html',
  styleUrls: ['../../shared-styles/login-device-view.component.scss', './login-mobile-mfa-step.component.scss'],
  standalone: false,
})
export class LoginMobileMfaStepComponent {
  public readonly login = inject(LoginComponent);

  @ViewChildren('mfaDigitInput') private mfaInputs!: QueryList<ElementRef<HTMLInputElement>>;

  public focusMfaInput(index: number): void {
    const input = this.mfaInputs?.toArray()?.[index]?.nativeElement;
    if (!input) {
      return;
    }

    input.focus();
    input.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
}
